import './navigation-drawer'
import './navigation-dropdown'
import './cookies'

const preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`

document
  .querySelectorAll('.service__intelligentFinance--preHeadingIcon')
  .forEach((el) => {
    el.innerHTML += preHeadingIcon
  })
document.querySelector(
  '.apps__intelligentFinance--left-preHeading-icon',
).innerHTML += preHeadingIcon
document.querySelector('.faq__feature-consulting--preHeading-icon').innerHTML +=
  preHeadingIcon

// Arrow Up Icon Button
const arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.btn.btn-talk-us').forEach((el) => {
  el.innerHTML += arrowUpIcon
  el.setAttribute('onclick', "location.href = 'contact-us.html';")
})
document.querySelector('.btn.btn-book-demo').innerHTML += arrowUpIcon

// FAQ
document.querySelectorAll('.faq__feature-consulting--faqItem').forEach((el) => {
  el.querySelector('.faq__feature-consulting--faqItem-header').addEventListener(
    'click',
    () => {
      if (el.classList.contains('active')) {
        el.classList.remove('active')
      } else {
        document
          .querySelectorAll('.faq__feature-consulting--faqItem')
          .forEach((el2) => {
            el2.classList.remove('active')
          })

        el.classList.add('active')
      }
    },
  )
})

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.btn-hamburger').innerHTML += hamburgerIcon

// Animation Single Element
const singleElements = [
  // Hero
  [
    '.hero__intelligentFinance--preHeading',
    'animate__fadeInUp',
    'animate__delay-1s',
  ],
  [
    '.hero__intelligentFinance--title',
    'animate__fadeInUpOneTenth',
    'animate__delay-3s',
  ],
  ['.hero__intelligentFinance--desc', 'animate__fadeInUp', 'animate__delay-5s'],
  [
    '.hero__intelligentFinance--partnerTitle',
    'animate__fadeInUp',
    'animate__delay-7s',
  ],
  [
    '.hero__intelligentFinance--partnerLogos',
    'animate__fadeInUp',
    'animate__delay-9s',
  ],
  [
    '.hero__intelligentFinance--illustration',
    'animate__fadeInUpOneTenth',
    'animate__delay-11s',
  ],
  // Service Points
  [
    '.servicePoints__intelligentFinance--preHeading',
    'animate__fadeInUp',
    'animate__delay-1s',
  ],
  [
    '.servicePoints__intelligentFinance--title',
    'animate__fadeInUpOneTenth',
    'animate__delay-3s',
  ],
  [
    '.servicePoints__intelligentFinance--desc',
    'animate__fadeInUpOneTenth',
    'animate__delay-5s',
  ],
  // App Integration
  [
    '.apps__intelligentFinance--left-preHeading',
    'animate__fadeInUp',
    'animate__delay-3s',
  ],
  [
    '.apps__intelligentFinance--left-heading',
    'animate__fadeInUpOneTenth',
    'animate__delay-5s',
  ],
  [
    '.apps__intelligentFinance--left-apps',
    'animate__fadeInUpOneTenth',
    'animate__delay-7s',
  ],
  [
    '.apps__intelligentFinance--left-notes',
    'animate__fadeInUpOneTenth',
    'animate__delay-9s',
  ],
  [
    '.apps__intelligentFinance--right-contentInner',
    'animate__fadeInUpOneTenth',
    'animate__delay-11s',
  ],
  [
    '.apps__intelligentFinance--right-illustration',
    'animate__fadeInUpOneTenth',
    'animate__delay-13s',
  ],
  // FAQ
  [
    '.faq__feature-consulting--preHeading',
    'animate__fadeInUp',
    'animate__delay-3s',
  ],
  ['.faq__feature-consulting--title', 'animate__fadeInUp', 'animate__delay-5s'],
  ['.faq__feature-consulting--desc', 'animate__fadeInUp', 'animate__delay-7s'],
  [
    '.faq__feature-consulting--contact',
    'animate__fadeInUp',
    'animate__delay-9s',
  ],
  [
    '.faq__feature-consulting--content',
    'animate__fadeInUpOneTenth',
    'animate__delay-11s',
  ],
  // CTA
  ['.section-cta__title', 'animate__fadeInUp', 'animate__delay-1s'],
  ['.section-cta__description', 'animate__fadeInUp', 'animate__delay-3s'],
  ['.btn.btn-book-demo', 'animate__fadeInUp', 'animate__delay-5s'],
]

// Create the observer like the examples above
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      entry.target.classList.add(
        'animate__animated',
        singleElements[index][1],
        singleElements[index][2],
      )
    }

    // entry.target.classList.remove('animate__animated')
  })
})
// , { threshold: 0.25 }

singleElements.forEach((element) => {
  observer.observe(document.querySelector(element[0]))
})

// Animation Multiple Element
const multipleElements = [
  // Service Intelligent
  [
    '.service__intelligentFinance--preHeading',
    'animate__fadeInUp',
    'animate__delay-1s',
  ],
  [
    '.service__intelligentFinance--title',
    'animate__fadeInUpOneTenth',
    'animate__delay-3s',
  ],
  [
    '.service__intelligentFinance--desc',
    'animate__fadeInUpOneTenth',
    'animate__delay-5s',
  ],
  ['.btn-talk-us', 'animate__fadeInUpOneTenth', 'animate__delay-7s'],
  [
    '.service__intelligentFinance--illustration',
    'animate__fadeInUpOneTenth',
    'animate__delay-9s',
  ],
]

multipleElements.forEach((element) => {
  document.querySelectorAll(element[0]).forEach((el) => {
    observer.observe(el)
  })
})
